module.exports = __webpack_public_path__ + "static/media/013.b7f76348.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/normals/013.jpg
// module id = 310
// module chunks = 0